<template>
  <v-app-bar app>
    <v-toolbar-title>Application</v-toolbar-title>
  </v-app-bar>
</template>

<script>
  export default { name: 'BaseAppBar' }
</script>
